import './styles.scss'
import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useHistory } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'

import { apiConversation } from 'api'
import { SocketDash, SocketWall } from '../../../socket'
import { removeUserTabs, setActiveChannel, setActiveUser, updateUserTabs } from '../../../redux/actions/tabs'
import { selectUser } from '../../../redux/actions/conversations/user'
import { usersHelpers } from '../../../utils'
import unreadMessagesAct from '../../../redux/actions/conversations/unreadMessagesAct'
import * as conversationsActions from '../../../redux/actions/conversations/conversations'
import composerAct from '../../../redux/actions/conversations/composerAct'
import poolLists from 'redux/poolLists/actions'
import { conversationAct } from 'redux_new/actions'
import { MnemonicsBadge } from '../../mnemonics'
import { toastMessage } from 'utils/messages'
import { getStaticImage } from 'utils/statics'
import { MultiAvatar } from 'components/common'
import { CHANNELINCHAT, typeInchat } from 'constants/channels'
import { getNamesCardInChat } from 'utils/usersHelpers'
import { validateOneDeactivatedUser } from 'components/InChatView/utils'
import { verifyFileVirus } from 'utils/FileUtils'

function Index(props) {
  const { expandedUserTab, activeUser, user, currentUser, chat, composer, frontOptions, isDragging, channelTabs, idOperator } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const { messages, unreadMessages } = chat

  const isActive = activeUser === user
  const isSupport = currentUser.state === 'list_support'
  const isDeactivated = currentUser.state === 'list_deactivated'
  const channel = channelTabs
  //const badgeColor = unreadMessages === 1 ? 'success' : unreadMessages === 2 ? 'warning' : unreadMessages === 3 ? 'danger' : 'danger blinking'

  const userAct = bindActionCreators(
    {
      removeUserTabs,
      updateUserTabs,
      selectUser,
      ...conversationsActions,
      ...unreadMessagesAct,
      ...composerAct,
      removeConversationNew: conversationAct.removeOne,
      listsAndUsers: poolLists.listsAndUsers,
      setActiveChannel
    },
    props.dispatch
  )

  useEffect(() => {
    SocketDash.subscribe(user)
    SocketWall.subscribe(props.currentUser._id)
    return () => {
      SocketDash.unsubscribe(user)
      SocketWall.unsubscribe(props.currentUser._id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const selectTab = async (e) => {
    const { user, activeUser } = props

    if (user !== activeUser) {
      // userAct.addConversation(user)
      // userAct.selectUser(user)
      userAct.setActiveChannel(channel)
      dispatch(setActiveUser(user))
      history.push(`${history.location.pathname}?user_id=${user}`)
      if(!CHANNELINCHAT.includes(channel)) userAct.setUserUnreadMessages(user, 0)
    }
  }

  const removeTab = () => {
    if (!CHANNELINCHAT.includes(channel)) {
      // Guardado de borrador
      const to = currentUser.provider_name === 'chatmail' && composer.chatmailHeader.to?.length
        ? composer.chatmailHeader.to
        : currentUser.provider_name !== 'chatmail'
          ? [{ id: user }]
          : undefined

      if (composer.message && to) {
        let data = {
          channel: currentUser.channels[0].channel,
          provider: currentUser.channels[0].provider,
          type: 'chat',
          to,
          message: {
            content: composer.message,
            attachments: composer.files,
            buttons: composer.buttons
          }
        }

        if (currentUser.provider_name === 'chatmail') {
          data = {
            ...data,
            ...composer.chatmailHeader,
            subject: composer.currentSubject.name,
            subjectId: composer.currentSubject._id
          }
        }

        if (composer.draftToEdit) {
          apiConversation.conversations.updateDraft({ draftId: composer.draftToEdit, data })
            .then(response => {
              const { existVirus } = verifyFileVirus({ data: response.data, dispatch: props.dispatch, userId: activeUser, updateFiles: userAct.updateFiles, sent: userAct.sent })
              if(existVirus) throw response
              if (response.status === 200) toastMessage(I18n.t('draft_successful_sent'))
            })
            .catch(() => toastMessage(I18n.t('draft_error_sent'), 'error'))
        } else {
          apiConversation.conversations.createDraft(data)
            .then(response => {
              const { existVirus } = verifyFileVirus({ data: response.data, dispatch: props.dispatch, userId: activeUser, updateFiles: userAct.updateFiles, sent: userAct.sent })
              if(existVirus) throw response
              if (response.status === 200) toastMessage(I18n.t('draft_successful_sent'))
            })
            .catch(() => toastMessage(I18n.t('draft_error_sent'), 'error'))
        }
      }
    }

    history.push(`${history.location.pathname}`)
    userAct.removeUserTabs(props.user)

    if (!CHANNELINCHAT.includes(channel)) {
      userAct.removeConversation(props.user)
      userAct.removeConversationNew(props.user)
    }

    if (history.location.pathname.includes('lists')) {
      userAct.listsAndUsers({
        selectType: frontOptions.poolListSelectType,
        channels: frontOptions.poolListChannel,
        brands: frontOptions.poolListBrands,
        delegations: frontOptions.poolListDelegations
      })
    }
  }

  const newUsersInfo = CHANNELINCHAT.includes(channelTabs)? Object.entries(currentUser).length !== 0 ? currentUser.usersInfo.filter((user)=>user._id !== idOperator): [] : []

  const tabName = CHANNELINCHAT.includes(channelTabs)
    ? getNamesCardInChat(newUsersInfo, currentUser.type, currentUser.name)
    : `${usersHelpers.showName(currentUser)}${currentUser.companyName ? ` - ${currentUser.companyName}` : ''}`

  const typeChannel = typeInchat.includes(currentUser.type)

  return (
    <div
      className={`
        tab
        ${isActive ? ' active' : ''}
        ${unreadMessages > 3 && isDeactivated ? ' urgent' : ''}
        ${isSupport ? ' support' : ''}
        ${isDragging ? ' bg-primary' : ''}
        ${expandedUserTab === user ? 'tab--expanded' : 'tab--default'}
      `}
      data-last-message={messages && messages[0] && messages[0].type}
      data-user={user}
      data-active={activeUser}
      draggable='true'
      title={tabName}
    >
      <div className={`content`} onMouseDown={selectTab} data-user={user} data-active={activeUser}>
        <MnemonicsBadge userId={currentUser.id} />
        {CHANNELINCHAT.includes(channelTabs)
          ? <div style={{
            opacity: !typeChannel && validateOneDeactivatedUser(newUsersInfo) ? 0.6 : 1
          }}>
            <MultiAvatar
              users={newUsersInfo}
              type={currentUser.type}
              conversationPrivate={currentUser.private}
              name={currentUser.name}
              mainWidth={20}
              className={`${typeChannel ? 'content__icon' : 'content__avatar'}`}
            />
          </div>
          : <img
            className='channel-icon-tab'
            src={`${getStaticImage(`/channels/orange-brand/${channel}-icon.svg`)}`}
            alt={`${channel}`}
            onError={event => {
              event.target.className = 'not-channel-icon'
              event.onerror = null
            }}
          />
        }
        <span
          data-user={user}
          data-active={activeUser}
          className='tab__user-name text-ellipsis'
        >
          {tabName}
        </span>
      </div>
      <button
        className='tab__icon-btn'
        onClick={removeTab}
      >
        <figure>
          <img
            src={getStaticImage('/icons/orange-brand/icon-close.svg')}
            alt='Close'
          />
        </figure>
      </button>
    </div>
  )
}

function mapStateToProps(state, props) {
  const { channelTabs } = props
  return {
    expandedUserTab: state.tabs.expandedUserTab,
    activeUser: state.tabs.activeUser,
    currentUser: CHANNELINCHAT.includes(channelTabs) && state.inchat.conversations[props.user]? state.inchat.conversations[props.user].conversation: state.conversations[props.user] ? state.conversations[props.user].user : {},
    chat: CHANNELINCHAT.includes(channelTabs) && state.inchat.conversations[props.user]? state.inchat.conversations[props.user].chat: state.conversations[props.user] ? state.conversations[props.user].chat : {},
    composer: CHANNELINCHAT.includes(channelTabs) && state.inchat.conversations[props.user]? state.inchat.conversations[props.user].composer: state.conversations[props.user] ? state.conversations[props.user].composer : {},
    frontOptions: state.user.frontOptions,
    idOperator: state.user.id
  }
}

export default connect(mapStateToProps)(Index)
